import { route, tag, type PageTour } from '../pageTour';

export const alertsTour: PageTour = {
  id: 'page-alerts',
  version: 1,
  title: 'Alert List',
  summary: 'Every alert for this site, with filters, search and bulk actions.',
  match: route('/alerts'),
  steps: [
    {
      target: tag('alerts-filters'),
      title: 'Filter alerts',
      description:
        'Use the filter column to search and narrow the list by alert type, severity, camera or time range.',
      side: 'right',
    },
    {
      target: tag('alerts-tabs'),
      title: 'Status tabs and view',
      description:
        'Switch between open, acknowledged, resolved and other alerts. On the right, choose Cards to see each alert’s picture or Table to see more at once.',
      side: 'bottom',
    },
    {
      target: tag('alerts-list'),
      title: 'Your alerts',
      description:
        'Every alert raised on this site. Acknowledge, assign or resolve one from its row, or click it to see the full record.',
      side: 'top',
    },
    {
      target: tag('alerts-refresh'),
      title: 'Refresh',
      description: 'Reload the list to pick up alerts raised since you opened the page.',
      side: 'bottom',
    },
  ],
};
